exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-config[data-v-a9d81b06]{width:500px;margin-left:10px;margin-top:10px}.tip[data-v-a9d81b06]{color:#f56c6c;margin-left:10px;margin-bottom:5px}.confirm-button-container[data-v-a9d81b06]{text-align:right}", ""]);

// exports
